import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { MeetingStep } from '../../../../types'
import PerButton from '../../../../components/custom_components/Button'
import PerSpacer from '../../../../components/custom_components/Spacer'

interface AppraisalStepBtnProps {
  nextStep: MeetingStep
  eventHandler?: Record<string, unknown>
  onClick?: () => void
  disabled?: boolean
  tooltip?: string | ReactNode
}

export const AppraisalBackBtn: FC<AppraisalStepBtnProps> = ({ nextStep, onClick, disabled, tooltip = '' }) => {
  const [t] = useTranslation()
  return (
    <PerSpacer mt="s">
      <PerButton
        type="button"
        text={t(`appraisalMeeting.meetingStepNamesByViewId.${nextStep.viewId}`)}
        data-e2e-back-step-button={nextStep.viewId}
        onClick={onClick}
        color="secondary"
        disabled={disabled}
        tabIndex={-1}
        before={'chevronLeft_stroke'}
        shadow
        tooltip={tooltip}
      />
    </PerSpacer>
  )
}

export const AppraisalNextBtn: FC<AppraisalStepBtnProps> = ({ nextStep, onClick, eventHandler, disabled, tooltip = '' }) => {
  const [t] = useTranslation()
  return (
    <PerSpacer mt="s">
      <PerButton
        type="button"
        text={t(`appraisalMeeting.meetingStepNamesByViewId.${nextStep.viewId}`)}
        data-e2e-next-step-button={nextStep.viewId}
        data-e2e-tooltip={tooltip}
        onClick={onClick}
        color="primary"
        disabled={disabled}
        after={'chevronRight_stroke'}
        shadow
        tooltip={tooltip}
        {...eventHandler}
      />
    </PerSpacer>
  )
}

export const MeetingConfirmBtn = ({
  onClick,
  onMouseDown,
  text,
  disabled = false,
  tooltip = '',
}: {
  onClick?: () => void
  onMouseDown?: () => void
  text?: string
  disabled?: boolean
  tooltip?: string
}): JSX.Element => {
  const [t] = useTranslation()
  return (
    <PerSpacer mt="s">
      <PerButton
        text={text ? text : t('global.button.confirm')}
        color="success"
        onMouseDown={onMouseDown}
        onClick={onClick}
        before="check_stroke"
        disabled={disabled}
        tooltip={tooltip}
        type="submit"
        data-e2e-confirm-step-button
        shadow
      />
    </PerSpacer>
  )
}
